module.exports = __webpack_public_path__ + "img/arrow-up-from-bracket.36e568e1.svg";